import { Box, Typography } from "@mui/material"
import React from "react"

type ProvidersGroupCellProps = {
  row: any
}

const ProvidersGroupCell = (props: ProvidersGroupCellProps) => {
  const { row } = props

  return (
    <Box
      sx={{
        // border: "1px solid red",
        display: "flex",
        flexDirection: "column",
        width: "fit-content",
      }}
    >
      <Box
        sx={{
          // border: "1px solid red",
          display: "flex",
          alignItems: "flex-start",
          flexWrap: "wrap",
        }}
      >
        {/* <Typography fontSize={14}>{row.original.Provider}</Typography>÷ */}
        <Typography fontSize={14}>{row?.original?.Group}</Typography>
      </Box>
      <Box
        sx={{
          // border: "1px solid red",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Typography color="gray" fontSize={10}>
          {row?.original?.Region}
        </Typography>
        {/* <Typography color="gray" fontSize={10}>
          {row?.original?.Office}
        </Typography> */}
      </Box>
    </Box>
  )
}

export default ProvidersGroupCell
